<div class="auth-wrapper">
	<div class="auth-shell">
		<div class="auth-container">
			
			<div class="overlay-container">
				<div class="overlay">
					<div class="overlay-panel overlay-right">
						<h1>Recuperação</h1>
						<p>Insira os dados solicitados para que possamos enviar instruções para gerar uma nova senha.</p>
					</div>
				</div>
			</div>

			<div class="form-container sign-in-container" *ngIf="!subscription">
				<form class="auth-form" [formGroup]="esqueciFormGroup">
					<img class="logo" src="assets/img/logo-sistema.png" />
					<h2>Esqueci a Senha</h2>
					<span class="sub-text">Preencha os campos abaixo</span>

					<div class="custom-input-group">
						<input type="text" class="custom-input" formControlName="user" placeholder="CPF" />
					</div>
					<div class="custom-input-group">
						<input type="email" class="custom-input" formControlName="email" placeholder="Email" />
					</div>

					<button type="submit" class="submit" [disabled]="esqueciFormGroup.invalid" (click)="onEnviar()">
						Solicitar Nova Senha
					</button>
					<a class="forgot-link" (click)="onVoltar()">Voltar ao Login</a>
				</form>
			</div>
			
			<div *ngIf="subscription" class="auth-loading-container">
				<mat-spinner [diameter]="48"></mat-spinner>
			</div>

		</div>
	</div>
</div>